// extracted by mini-css-extract-plugin
export default {"container":"qa_container__BxTR9","qa_container_left":"qa_qa_container_left__otLcm","qa_container_right":"qa_qa_container_right__aadEz","link_btn":"qa_link_btn__aSe5N"};